import styled from 'styled-components';

export const LogoWrapper = styled.div`
  height: 100%;
  width: 100%;
  cursor: pointer;
`;
